import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { COMPRESSION_PILE } from "../../../../constants";
import { selectLoadType, selectResistanceFactor } from "../../../../store/slices/aashtoSlice";
import InfoIcon from "../../../../components/Icons/InfoIcon";
import ToolTip, { IconType } from "../../../../components/ToolTip";

function ResistanceFactor({ showImage, show }) {
  const { t } = useTranslation("translation");

  const loadType = useSelector(selectLoadType);
  const resistanceFactor = useSelector(selectResistanceFactor);

  let subVar;
  function buildIndicesValue() {
    if (loadType === COMPRESSION_PILE) {
      subVar = "CU";
    } else {
      subVar = "TU";
    }

    return (
      <span>
        &Phi;<sub>{subVar}</sub>
      </span>
    );
  }

  return (
    <RowBody
      titleValue={<p>{t("aashto.inner.Resistance Factor")}</p>}
      indicesValue={buildIndicesValue()}
      inputValue={
        <span className="input">
          <NumberFormatText value={resistanceFactor} decimalScale={2} />
        </span>
      }
      unitValue={""}
      formulaValue={
        <>
          <span onClick={() => showImage(!show)}>
            <PlusIcon />
          </span>
          <span>
            <ToolTip
              id={"ResistanceFactorInfoText"}
              type={IconType.InfoIcon}
              text={t("aashto.inner.ResistanceFactorInfoText")}
            />
          </span>
        </>
      }
    />
  );
}

export default ResistanceFactor;
